import React from 'react';

import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

import classes from "./ListItem.css";
const ListItemNav = (props) => {
    let Icon = props.icon;

    return (
        <ListItem button className={classes.ListItem}>
            {Icon ? <ListItemIcon style={{ color: props.color }}>
                <Icon />
            </ListItemIcon> : null
            }
            <ListItemText style={{ color: props.textColor }} primary={props.text} />
            {props.children}
        </ListItem>
    );
}

export default ListItemNav;